module.exports = __webpack_public_path__ + "media/scripts/pages/join/assets/media/partners/mediacorp-seeklogo.com-01-d198295b0dd545e9f78b07fe508b5057.svg";